import { useCachedResource } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";
import { breaks } from "../local/db";

// #642/#638 — the ring's scheduled breaks. These are NOT rides: reconcile drops
// FVD's ***Break*** / ***Lunch*** placeholders before they can become score-ride
// rows (#585, by design — a break must never be scored, placed or emailed) and
// projects them into their own score-break table instead. So the Order of Go
// merges two lists client-side; a break will never appear in GET /ride.
//
// GET /break already returns rows sorted by scheduledTime (missing last), but we
// re-sort anyway when merging with rides.
export function useBreaksForRing(showId, ring, online, nonce = 0) {
  const api = useScoreApi();
  return useCachedResource(
    async () => {
      if (!showId || !ring) return undefined;
      const cached = (await breaks.byShow(showId)).filter(
        (b) => String(b.ring) === String(ring),
      );
      return cached.length ? cached : undefined;
    },
    async () => {
      if (!showId || !ring) return [];
      const list = unwrap(await api.breaks.listBreaks(showId, ring));
      await breaks.putAll(list ?? []);
      return list ?? [];
    },
    [api, showId, ring, nonce],
    online,
  );
}

export default useBreaksForRing;
